
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillInvoice } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        invoices: {
            type: Array as PropType<Array<WaybillInvoice>>,
            default: () => []
        }
    },
    setup(props) {
        const getTotalValueByKey = (key: keyof WaybillInvoice): number => {
            return props.invoices.reduce((sum, invoice) => {
                const value = invoice[key];
                return sum + (typeof value === "number" ? value : 0)
            }, 0)
        }

        return {
            getTotalValueByKey
        }
    }
})
